/**
 * Centralised matcher for routes whose search intent is explicitly
 * "no signup / no registration".
 *
 * Since 2026-10-08 this NO LONGER exempts a session from the signup gate:
 * those pages truthfully offer ONE scan without signup, and the second scan
 * requires signup like everywhere else (enforced server-side in vision-ocr).
 * The session marker is kept only as an attribution hint; nothing gates on it.
 */
const NO_SIGNUP_PATTERNS = [
  "no-signup",
  "no-sign-up",
  "nosignup",
  "no-registration",
  "no-register",
  "without-signup",
  "without-registration",
  "no-account",
];

const SESSION_KEY = "factscan:no-signup-exempt";

export function isNoSignupPath(pathname: string): boolean {
  const p = (pathname || "").toLowerCase();
  return NO_SIGNUP_PATTERNS.some((pattern) => p.includes(pattern));
}

export function markNoSignupExemptionIfApplicable(pathname: string): void {
  if (!isNoSignupPath(pathname)) return;
  try {
    window.sessionStorage.setItem(SESSION_KEY, "1");
  } catch {
    // storage unavailable — exemption falls back to path-only matching
  }
}

export function isSessionNoSignupExempt(): boolean {
  try {
    if (typeof window === "undefined") return false;
    if (window.sessionStorage.getItem(SESSION_KEY) === "1") return true;
    return isNoSignupPath(window.location.pathname);
  } catch {
    return typeof window !== "undefined" && isNoSignupPath(window.location.pathname);
  }
}
